<template>
  <div class="pt20">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('studentManagement.back') }}</span>
    </div>
    <h4>{{ id ? $t('studentManagement.editStudent') : $t('studentManagement.createStudent') }}</h4>
    <a-form :form="form" layout="vertical">
      <div class="title">{{ $t('studentManagement.basicInfo') }}</div>
      <div class="list">
        <a-form-item class="full" :label="$t('studentManagement.studentName')" :colon="false">
          <a-input
            maxLength="20"
            :placeholder="$t('studentManagement.inputStudentName')"
            v-decorator="['name', { rules: [{ required: true, message: $t('studentManagement.inputStudentName') }] }]"
          ></a-input>
        </a-form-item>
        <a-form-item :label="$t('studentManagement.loginAccount')" :colon="false">
          <a-input
            maxLength="13"
            :addon-after="shortName"
            :placeholder="$t('studentManagement.accountPlaceholder')"
            v-decorator="[
              'username',
              { rules: [{ required: true, message: $t('studentManagement.loginAccount') }, { validator: checkName }] }
            ]"
          ></a-input>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('studentManagement.password')" :colon="false">
          <a-input
            maxLength="13"
            autocomplete="new-password"
            :type="!passwordFlag ? 'password' : 'text'"
            v-decorator="['password', { rules: [{ required: isRequired, message: $t('studentManagement.inputPassword') }] }]"
            :placeholder="$t('studentManagement.passwordPlaceholder')"
          >
            <img
              @click="passwordFlag = true"
              v-if="!passwordFlag"
              src="@/assets/icons/icon_bi.png"
              slot="suffix"
              alt=""
            />
            <img 
              @click="passwordFlag = false" 
              v-else 
              src="@/assets/icons/icon_kai.png" 
              slot="suffix" 
              alt="" 
            />
          </a-input>
        </a-form-item>
        <a-form-item :label="$t('studentManagement.confirmPassword')" :colon="false">
          <a-input
            maxLength="13"
            autocomplete="new-password"
            :type="!repasswordFlag ? 'password' : 'text'"
            :placeholder="$t('studentManagement.inputConfirmPassword')"
            v-decorator="[
              'repassword',
              { rules: [{ required: isRequired, message: $t('studentManagement.inputConfirmPassword') }, { validator: compareToFirstPassword }] }
            ]"
          >
            <img
              @click="repasswordFlag = true"
              v-if="!repasswordFlag"
              src="@/assets/icons/icon_bi.png"
              slot="suffix"
              alt=""
            />
            <img 
              @click="repasswordFlag = false" 
              v-else 
              src="@/assets/icons/icon_kai.png" 
              slot="suffix" 
              alt="" 
            />
          </a-input>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('studentManagement.gender')" :colon="false">
          <a-select
            allowClear
            v-decorator="['gender', { rules: [{ required: true, message: $t('studentManagement.selectGender') }] }]"
            :placeholder="$t('studentManagement.selectGender')"
          >
            <a-select-option value="1">{{ $t('studentManagement.male') }}</a-select-option>
            <a-select-option value="2">{{ $t('studentManagement.female') }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('studentManagement.phone')" :colon="false">
          <a-input
            v-decorator="[
              'phone',
              {
                rules: [{ validator: validatePhone }]
              }
            ]"
            :placeholder="$t('studentManagement.phonePlaceholder')"
            @input="handlePhoneInput"
          />
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item :label="$t('studentManagement.email')" :colon="false">
          <a-input
            maxLength="50"
            v-decorator="[
              'email',
              {
                rules: [{ validator: validateEmail }]
              }
            ]"
            :placeholder="$t('studentManagement.emailPlaceholder')"
          />
        </a-form-item>
        <a-form-item :label="$t('studentManagement.studentNumber')" :colon="false">
          <a-input
            maxLength="30"
            v-decorator="['studentNumber']"
            :placeholder="$t('studentManagement.inputStudentNumber')"
          />
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item :label="$t('studentManagement.enrollmentYear')" :colon="false">
          <a-select
            allowClear
            v-decorator="['enrollmentYear', { rules: [{ required: true, message: $t('studentManagement.selectEnrollmentYear') }] }]"
            :placeholder="$t('studentManagement.selectEnrollmentYear')"
          >
            <a-select-option v-for="year in yearList" :key="year" :value="year">
              {{ year }}{{ $t('studentManagement.year') }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="full" :label="$t('studentManagement.userRole')" :colon="false">
          <a-select
            allowClear
            v-decorator="['userRole', { rules: [{ required: true, message: $t('studentManagement.selectUserRole') }] }]"
            :placeholder="$t('studentManagement.selectUserRole')"
          >
            <a-select-option value="3">{{ $t('studentManagement.student') }}</a-select-option>
            <a-select-option value="1">{{ $t('studentManagement.teachingAssistant') }}</a-select-option>
            <a-select-option value="2">{{ $t('studentManagement.classRepresentative') }}</a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item :label="$t('studentManagement.department')" :colon="false">
          <a-input
            maxLength="20"
            v-decorator="['department']"
            :placeholder="$t('studentManagement.inputDepartment')"
          />
        </a-form-item>
        <a-form-item class="full" :label="$t('studentManagement.status')" :colon="false">
          <a-select
            allowClear
            v-decorator="['status', { rules: [{ required: true, message: $t('studentManagement.selectStatus') }] }]"
            :placeholder="$t('studentManagement.selectStatus')"
          >
            <a-select-option value="1">{{ $t('studentManagement.statusEnabled') }}</a-select-option>
            <a-select-option value="0">{{ $t('studentManagement.statusDisabled') }}</a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item :label="$t('studentManagement.remark')" :colon="false">
          <a-textarea
            :rows="4"
            maxLength="500"
            v-decorator="['remark']"
            :placeholder="$t('studentManagement.remarkPlaceholder')"
          />
        </a-form-item>
      </div>
      <div class="submit-button">
        <a-button type="primary" @click="handleSubmit">{{ $t('studentManagement.save') }}</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import cookie from 'js-cookie'
import moment from 'moment'
import { studentSave, studentDetail } from '@/api/admin'
import { getAdminOrgList } from '@/api/lesson'
import md5 from 'md5'

export default {
  data() {
    return {
      id: undefined,
      passwordFlag: true,
      repasswordFlag: true,
      form: this.$form.createForm(this),
      shortName: '@' + cookie.getJSON('user_infor').username.split('@')[1],
      professionList: [],
      isRequired: true,
      emailSuffixes: [
        '@qq.com',
        '@163.com',
        '@126.com',
        '@gmail.com',
        '@hotmail.com',
        '@outlook.com',
        '@yahoo.com',
        '@sina.com',
        '@sohu.com'
      ],
      yearList: [],
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: 'organizationStudentList'
      })
    },
    checkName(rule, value, callback) {
      if (/.*[\u4e00-\u9fa5]+.*$/.test(value)) {
        callback('不支持输入中文')
      } else {
        callback()
      }
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        callback(this.$t('studentManagement.passwordMismatch'));
      } else {
        callback()
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          let pd = ''
          if (
            values.password !== '' &&
            values.password !== undefined &&
            values.repassword !== undefined &&
            values.repassword !== ''
          ) {
            pd = md5(values.password)
          } else if (
            values.password !== '' &&
            values.password !== undefined &&
            (values.repassword === undefined || values.repassword === '')
          ) {
            this.$message.error(this.$t('studentManagement.inputConfirmPassword'))
            return
          } else {
            pd = ''
          }

          const data = {
            ...values,
            id: this.id,
            username: values.username + this.shortName,
            password: pd,
            // professionId: values.profession[2],
            // departmentId: values.profession[1],
            // collegeId: values.profession[0],
            enrollmentDate: values.enrollmentDate ? moment(values.enrollmentDate).format('YYYY-MM-DD') : undefined,
            enrollmentYear: values.enrollmentYear,
            userRole: values.userRole
          }
          delete data.repassword
          // delete data.profession

          // TODO: Add API call to save student data
          console.log('Form data:', data)
          studentSave(data).then(res => {
            if (res.code == 200) {
              this.$message.success(this.$t('studentManagement.saveSuccess'))
              this.$router.push({
                name: 'organizationStudentList'
              })
            }
          })
        }
      })
    },
    professionMapHttp() {
      getAdminOrgList().then(res => {
        if (res.code === 200) {
          for (const item of res.data.list) {
            this.professionList.push({
              value: item.id,
              label: item.name,
              children: item.child.map(items => ({
                value: items.id,
                label: items.name,
                children: items.child.map(itemt => ({
                  value: itemt.id,
                  label: itemt.name
                }))
              }))
            })
          }
        }
      })
    },
    validatePhone(rule, value, callback) {
      const phoneRegex = /^1[3-9]\d{9}$/
      if (value && !phoneRegex.test(value)) {
        callback(this.$t('studentManagement.invalidPhone'))
      } else {
        callback()
      }
    },
    handlePhoneInput(e) {
      const value = e.target.value
      const newValue = value.replace(/\D/g, '')
      if (value !== newValue) {
        e.target.value = newValue
        this.form.setFieldsValue({ phone: newValue })
      }
    },
    validateEmail(rule, value, callback) {
      if (!value) {
        callback()
        return
      }

      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
      if (!emailRegex.test(value)) {
        callback(this.$t('studentManagement.invalidEmail'))
        return
      }

      const atIndex = value.indexOf('@')
      const emailSuffix = value.substring(atIndex)
      if (!this.emailSuffixes.includes(emailSuffix)) {
        callback(this.$t('studentManagement.useCommonEmailSuffix'))
        return
      }

      callback()
    },
    onChange(value) {
      console.log(value)
    },
    generateYearList() {
      const currentYear = new Date().getFullYear()
      for (let year = currentYear; year >= 1990; year--) {
        this.yearList.push(String(year))
      }
    },
    getTeacherDetail() {
      studentDetail({ id: this.id }).then(res => {
        if (res.code === 200) {
          for (const key in res.data) {
            if (res.data[key] === '0') res.data[key] = undefined
          }
          this.form.setFieldsValue({
            ...res.data,
            profession: !res.data.professionId ? ''
              : [res.data.collegeId, res.data.departmentId, res.data.professionId],
            username: res.data.username.split('@')[0]
          })
        }
      })
    }
  },
  mounted() {
    this.id = this.$route.query.id || undefined
    this.professionMapHttp()
    this.generateYearList()
    if (this.id) {
      // TODO: Add API call to get student detail
      setTimeout(() => {
        this.getTeacherDetail()
        this.isRequired = false
      }, 100)
    }
  }
}
</script>

<style lang="less" scoped>
// Reuse the same styles from teacher/add.vue
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}

.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;

  img {
    height: 10px;
    margin-right: 9px;
  }
}

/deep/ .ant-form {
  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #ededed;

    &::before {
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6b738c;
    }
  }

  .list {
    display: flex;
    padding-right: 200px;

    .ant-form-item-label label {
      color: #000000;
    }

    .ant-form-item {
      width: 50%;
      padding-left: 45px;

      &:first-child {
        padding-left: 0;
        padding-right: 45px;
      }
    }

    .ant-input-affix-wrapper .ant-input-suffix {
      position: absolute;

      img {
        width: 23px;
        height: 23px;
        opacity: 0.3;
      }
    }

    .ant-calendar-picker div {
      position: relative;
    }

    .ant-input,
    .ant-select {
      border-radius: 4px;
      color: #000000;
    }

    .full .ant-input,
    .full .ant-select {
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      border-radius: 4px;
    }

    .ant-textarea {
      border-radius: 4px;
      color: #000000;
      resize: none;
    }
  }

  .submit-button {
    width: 100%;
    text-align: center;
    margin-top: 100px;
  }
}

/deep/ .anticon {
  color: #d5d5d5 !important;
}

.ant-calendar-picker {
  width: 100%;
}
</style>
